import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { signOut } from 'firebase/auth';
import { auth } from '@/core/firebase/config';

export const Route = createFileRoute('/logout')({
  component: Logout,
});

function Logout() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate({ to: '/' });
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  // Automatically trigger logout when component mounts
  handleLogout();

  return (
    <div className="p-2">
      <p>Logging out...</p>
    </div>
  );
}
